import { render, staticRenderFns } from "./YuQueBindCom.vue?vue&type=template&id=d8b85a6a&scoped=true"
import script from "./YuQueBindCom.vue?vue&type=script&lang=js"
export * from "./YuQueBindCom.vue?vue&type=script&lang=js"
import style0 from "./YuQueBindCom.vue?vue&type=style&index=0&id=d8b85a6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8b85a6a",
  null
  
)

export default component.exports